var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17067_301533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8303 5.00747C19.2535 4.29309 17.5888 3.78628 15.8789 3.5C15.6449 3.91393 15.4332 4.3398 15.2446 4.77584C13.4232 4.50424 11.571 4.50424 9.74961 4.77584C9.56095 4.33984 9.34924 3.91398 9.11535 3.5C7.40433 3.7887 5.7386 4.29671 4.16019 5.01121C1.02664 9.599 0.177189 14.0729 0.601917 18.4832C2.437 19.8249 4.49098 20.8453 6.67458 21.5C7.16626 20.8456 7.60134 20.1514 7.97519 19.4247C7.26511 19.1622 6.57975 18.8384 5.92706 18.457C6.09884 18.3337 6.26684 18.2067 6.42918 18.0834C8.32837 18.9673 10.4012 19.4255 12.5 19.4255C14.5987 19.4255 16.6715 18.9673 18.5707 18.0834C18.735 18.2161 18.903 18.3431 19.0729 18.457C18.4189 18.839 17.7323 19.1635 17.0209 19.4265C17.3943 20.1529 17.8294 20.8465 18.3216 21.5C20.507 20.8479 22.5626 19.828 24.398 18.4851C24.8963 13.3705 23.5467 8.93773 20.8303 5.00747ZM8.51318 15.7709C7.32961 15.7709 6.35179 14.708 6.35179 13.4004C6.35179 12.0928 7.29563 11.0205 8.5094 11.0205C9.72318 11.0205 10.6934 12.0928 10.6727 13.4004C10.6519 14.708 9.71941 15.7709 8.51318 15.7709ZM16.4867 15.7709C15.3013 15.7709 14.3272 14.708 14.3272 13.4004C14.3272 12.0928 15.2711 11.0205 16.4867 11.0205C17.7024 11.0205 18.6651 12.0928 18.6444 13.4004C18.6236 14.708 17.693 15.7709 16.4867 15.7709Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17067_301533"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 24,
    height: 24,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscordIcon);
export default __webpack_public_path__ + "static/media/discord-icon.1b02fc49f2a6910d05db96fdfbb4db81.svg";
export { ForwardRef as ReactComponent };